var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivitySavedSuccessfulyImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 177,
    viewBox: "0 0 197 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6816 87.7684L120.148 34.6406L27.6816 87.7684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6816 87.7684L120.148 34.6406",
    stroke: "#E5E5E5",
    strokeWidth: 22.6258,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6777 122.614L142.144 69.4863L49.6777 122.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6777 122.614L142.144 69.4863",
    stroke: "#E5E5E5",
    strokeWidth: 22.6258,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.828 56.1356L173.035 51.9404L165.828 56.1356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.828 56.1356L173.035 51.9404",
    stroke: "#E5E5E5",
    strokeWidth: 22.6258,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.2988 151.281L152.524 110.263L82.2988 151.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2988 151.281L152.524 110.263",
    stroke: "#E5E5E5",
    strokeWidth: 22.6258,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.714 114.224C170.838 114.341 171.656 115.349 171.539 116.474C171.421 117.599 170.413 118.417 169.288 118.299C168.163 118.182 167.346 117.173 167.463 116.049C167.58 114.924 168.589 114.106 169.714 114.224Z",
    stroke: "#038128",
    strokeWidth: 1.05331
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2046 156.018C52.0541 156.211 53.3989 157.869 53.2058 159.719C53.0127 161.568 51.3543 162.913 49.5048 162.72C47.6554 162.527 46.3105 160.869 46.5036 159.019C46.6967 157.17 48.3551 155.825 50.2046 156.018Z",
    stroke: "#038128",
    strokeWidth: 1.73209
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.353 17.8821C99.2025 18.0752 100.547 19.7336 100.354 21.5831C100.161 23.4326 98.5027 24.7774 96.6533 24.5843C94.8038 24.3912 93.459 22.7328 93.6521 20.8833C93.8452 19.0339 95.5036 17.689 97.353 17.8821Z",
    stroke: "#038128",
    strokeWidth: 1.73209
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3459 61.7588C20.1954 61.7588 20.8852 62.4485 20.8852 63.2981C20.8852 64.1476 20.1954 64.8373 19.3459 64.8373C18.4964 64.8373 17.8066 64.1476 17.8066 63.2981C17.8066 62.4485 18.4964 61.7588 19.3459 61.7588Z",
    stroke: "#038128",
    strokeWidth: 1.26609
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.899 162.138C139.748 162.138 140.438 162.827 140.438 163.677C140.438 164.526 139.748 165.216 138.899 165.216C138.049 165.216 137.359 164.526 137.359 163.677C137.359 162.827 138.049 162.138 138.899 162.138Z",
    stroke: "#4D5762",
    strokeWidth: 1.26609
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.459 17.4033L158.216 11.4802",
    stroke: "#4D5762",
    strokeWidth: 0.737688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.473 13.6055L160.396 15.3627",
    stroke: "#4D5762",
    strokeWidth: 0.737688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5898 118.264L27.1304 112.281",
    stroke: "#4D5762",
    strokeWidth: 0.737688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4668 114.54L29.4499 116.081",
    stroke: "#4D5762",
    strokeWidth: 0.737688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.016 144.992L155.221 138.933",
    stroke: "#4D5762",
    strokeWidth: 0.737688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.689 141.393L157.749 142.598",
    stroke: "#4D5762",
    strokeWidth: 0.737688
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5275 43.8115C123.044 43.8115 142.949 63.717 142.949 88.2335C142.949 112.75 123.044 132.656 98.5275 132.656C74.011 132.656 54.1055 112.75 54.1055 88.2335C54.1055 63.717 74.011 43.8115 98.5275 43.8115Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4999 48.0137C120.698 48.0137 138.721 66.0365 138.721 88.2343C138.721 110.432 120.698 128.455 98.4999 128.455C76.3022 128.455 58.2793 110.432 58.2793 88.2343C58.2793 66.0365 76.3022 48.0137 98.4999 48.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3359 89.7097L91.2097 100.336L116.664 74.8818",
    stroke: "#038128",
    strokeWidth: 7.86867
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySavedSuccessfulyImage);
export default __webpack_public_path__ + "static/media/activity_saved_successfuly_image.c024108ddca793d4726f00709cb0401e.svg";
export { ForwardRef as ReactComponent };